/**
 * This file is to map trigger, from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { recurringTriggerEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import {
	getEdge,
	getValudOfVariable,
} from "../../../../../containers/editor/utils/utils";

const getShadows = (condition) => {
	let shadows = [];
	let varValue;
	if (condition.or) {
		varValue = getValudOfVariable(
			condition.or[condition.or.length - 1].eq?.var
		).replace("input.data.step in ", "");

		if (varValue[0] !== "[") return false;
		shadows = JSON.parse(varValue).filter((v) => !v.includes("_loop"));
	}
	return shadows;
};

/**
 *
 * @param {*} audience
 */
const parseBEOnScheduleToFE = (
	trigger,
	nextSubAutomation,
	nextStepCondition,
	nextType,
	index
) => {
	let shadows = [];
	if (nextStepCondition) {
		shadows = getShadows(nextStepCondition);
	}
	const id = `event_${+new Date()}${index}`;
	const triggerEvent = {
		id: id,
		type: "editorNode",
		data: {
			baseId: "onSchedule",
			id: id,
			...recurringTriggerEvents()[0],
			initialElement: true,
			shadows: shadows,
			defaultValues:{
				time: trigger.args.time,
				timezone: trigger.args.timezone
			}
		},
	};
	const firstTargetId = nextSubAutomation.id;
	const links = getEdge("branchingEdge", triggerEvent.id, firstTargetId);
	return {
		events: [triggerEvent],
		links: [links],
	};
};
const parseFEOnScheduleToBE = (FEEvent, events) => {
	return {
		args: {
			time: FEEvent.data.defaultValues.time,
			timezone: FEEvent.data.defaultValues.timezone
		},
		name:"On.Schedule"
	};
};
export { parseFEOnScheduleToBE, parseBEOnScheduleToFE };
